// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__ECUDj","control":"Checkout_control__hgt_w","actions":"Checkout_actions__34vzd","submit":"Checkout_submit__-PWFm","invalid":"Checkout_invalid__2caWg"};